import React from 'react';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { Tabs, Tab, Paper, Box, Typography } from '@material-ui/core';
import './ContingentSchoolTranslate';
import { useTranslation } from 'react-i18next';
import paths from '../../_helpers/paths';
import { Link } from 'react-router-dom';
import ExportIcon from '@material-ui/icons/SaveAlt';
import Button from '../../_ui/Button/Button';
import AddIcon from '@material-ui/icons/Add';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Color } from '../../components/ThemeProvider/ThemeStyle';
import PupilsPage from './Pupils/PupilsPage'
import RetiredPage from './Retired/RetiredPage'
import {contingentSchoolModule} from './ContingentSchoolDucks'

export default function ContingentSchoolPage({ location: { pathname } }) {
  const { t } = useTranslation();

  const breadCrumbItems = [
    { name: t('breadcrumbs_home'), href: '/' },
    { name: t('breadcrumbs_contingentSchool'), href: paths.contingentPupilsPage }
  ];

  const pupilsUrl = paths.contingentPupilsPage;
  const retiredUrl = paths.contingentRetiredPage;
  const pupilsTotal = useSelector(state => state[contingentSchoolModule].pupils.totalElements);
  const retiredTotal = useSelector(state => state[contingentSchoolModule].retired.totalElements);

  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <Paper 
        style={{ position: 'relative' }}
      >
        <Box className='flex justify-between'>
          <Box className={Color.isDark ? 'flex contingent_dark' : 'flex contingent'} style={{zIndex: 9}}>
            <Tabs 
              value={pathname} 
              indicatorColor={Color.isDark ? '#252525' : '#fff'}
            >
              <Tab
                label={t('contingentSchool_pupilsTitle')}
                value={pupilsUrl}
                component={Link}
                to={pupilsUrl}
                style={{
                  fontWeight: '700',
                  border: '1px solid #e1e1e1',
                  borderBottom: 'none',
                  borderLeft: 'none',
                  backgroundColor: '#e1e1e185'
                }}
              />
              <Tab
                label={t('contingentSchool_retiredTitle')}
                value={retiredUrl}
                component={Link}
                to={retiredUrl}
                style={{
                  fontWeight: '700',
                  border: '1px solid #e1e1e1',
                  borderBottom: 'none',
                  backgroundColor: '#e1e1e185'
                }}
              />
            </Tabs>
            <Box style={{marginTop: '3px', marginLeft: '10px', display: 'flex', alignItems: 'center'}}>
              <Button
                text={t('journalPage_export_btn')}
                icon={<ExportIcon fontSize="small" className="mr1" />}
                onClick={() => {}}
              />
              <Typography style={{ marginLeft: '10px'}}>
                {t('colleaguesPassport_numberEmployees')} {' '} {pathname === pupilsUrl ? pupilsTotal : retiredTotal}
              </Typography>
            </Box>
          </Box>
          {
            pathname === pupilsUrl &&
            <Box className='mr3' style={{marginTop: '5px'}}>
              <Button
                icon={<AddIcon fontSize="small" className="mr1" />}
                size="small"
                text={t('contingentSchool_addBtn')}
                component={NavLink}
               to={'/contingent/school'}
              />
            </Box>
          }
        </Box>
        <div className="px3 pb3 pt1 relative" style={{ borderTop: '1px solid #e1e1e1', marginTop: '-1px', }}>
          {pathname === pupilsUrl && <PupilsPage /> }
          {pathname === retiredUrl && <RetiredPage />}
        </div>

      </Paper>
    </>
  );
}
